import { hasAuthoritativeFieldBoundaries } from "./fieldMapAuthority.js";

function isBlank(value) {
  return value === null || value === undefined || String(value).trim() === "";
}

function invalidCoordinate(value, limit) {
  return isBlank(value) || !Number.isFinite(Number(value)) || Math.abs(Number(value)) > limit;
}

function buildFieldValidationErrors(field = {}) {
  const hasBoundaries = hasAuthoritativeFieldBoundaries(field);
  return {
    name: isBlank(field.name),
    fieldSize: !isBlank(field.field_size) && (!Number.isFinite(Number(field.field_size)) || Number(field.field_size) <= 0),
    fieldAddress: false,
    latitude: !hasBoundaries && !isBlank(field.latitude) && invalidCoordinate(field.latitude, 90),
    longitude: !hasBoundaries && !isBlank(field.longitude) && invalidCoordinate(field.longitude, 180),
    surfaceForm: false,
    slopeClass: false,
    soilType: false,
    surfaceSoilTexture: false,
    topsoilHorizonThickness: !isBlank(field.topsoil_horizon_thickness_cm) && (!Number.isFinite(Number(field.topsoil_horizon_thickness_cm)) || Number(field.topsoil_horizon_thickness_cm) <= 0 || Number(field.topsoil_horizon_thickness_cm) > 1000),
  };
}

export { buildFieldValidationErrors };
